import type { ContentBlock } from '@/lib/blogContentBlocks';

/**
 * Shared renderer for structured blog content. Consumes the same
 * `ContentBlock[]` shape regardless of where it came from — parsed from a
 * legacy WordPress-imported post (see parseContentBlocks) today, or
 * authored directly through a future CMS. Each block already carries its
 * final, sanitized markup, so this renders byte-identical output to the
 * single-blob `dangerouslySetInnerHTML` approach it replaces.
 */
export function BlogContentBlocks({ blocks }: { blocks: ContentBlock[] }) {
  return (
    <>
      {blocks.map((block, i) => (
        <div key={i} data-block-type={block.type} dangerouslySetInnerHTML={{ __html: block.html }} />
      ))}
    </>
  );
}
